import Login from './screens/Authentication/Login';
import LoginV2 from './screens/Authentication/LoginV2';
import LoginCompany from './screens/LoginCurrentUser';

const route = [
    { path: '/auth/login', exact: true, name: 'Login 1', component: Login },
    { path: '/auth/loginV2', exact: true, name: 'Login 2', component: LoginV2 },
    { path: '/company', exact: true, name: 'Login Company', component: LoginCompany },
];
export default route;
